import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance90 = () => {
  let winners = ["512"];
  return <IndividualTable matchType={"2"} gender="M" event="90" subTitle="TarscaShild" data={sampleData} topRankCount="1" winners={winners} />;
};
export default Distance90;
